import tokenData from '../../design-tokens/base-tokens.json';
import { createTheme } from '@mui/material/styles';
let theme = createTheme();
export const MuiDrawer = {
    styleOverrides: {
        root: {
            overflow: 'hidden',
            paddingTop: 64,
            paddingBottom: 128,
            minWidth: 240,
            '&& .MuiDrawer-paper': {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            '& .MuiDialogActions-root': {
                bottom: 0
            }
        },
        paper: {
            minWidth: 240,
            overflow: 'hidden',
            minHeight: '100%',
            borderColor: tokenData.tokens.palette.grey.grey100
        }
    }
};
export default MuiDrawer;
